/* @flow */

import ChangePasswordRequest from 'models/requests/users/changePasswordRequest';

export default class ChangePasswordForm {
  currentPassword: string;
  password: string;
  confirmPassword: string;

  constructor() {
    this.currentPassword = '';
    this.password = '';
    this.confirmPassword = '';
  }

  toRequest(twoFactorPin: string, smsCode: string) {
    const request = new ChangePasswordRequest();
    request.currentPassword = this.currentPassword;
    request.newPassword = this.password;
    request.twoFactorPin = twoFactorPin;
    request.smsCode = smsCode;
    return request;
  }
}
